(function () {
  'use strict';

  var root = document.getElementById('sc-apdp');
  if (!root || !window.SC_ACC || !window.SCVariantSelect) return;

  var DATA = window.SC_ACC;
  var VARIANTS = DATA.variants || [];
  if (!VARIANTS.length) return;

  var elOptions = document.getElementById('sc-apdp-options');
  var elPrice = document.getElementById('sc-apdp-price');
  var elCompare = document.getElementById('sc-apdp-compare');
  var elSave = document.getElementById('sc-apdp-save');
  var elSku = document.getElementById('sc-apdp-sku');
  var elStock = document.getElementById('sc-apdp-stock');
  var elVid = document.getElementById('sc-apdp-vid');
  var elAdd = document.getElementById('sc-apdp-add');
  var elQty = document.getElementById('sc-apdp-qty');

  /* The gallery owns the hero and the thumb strip together — see
     snippets/pdp-gallery.liquid. Null when the product has no images. */
  var gallery = window.SCGallery ? window.SCGallery.mount('sc-apdp') : null;

  function renderBuy(v) {
    if (!v) {
      elAdd.disabled = true;
      elAdd.textContent = 'Unavailable';
      elStock.textContent = 'Not available';
      elStock.setAttribute('data-out', 'true');
      return;
    }
    elVid.value = v.id;
    /* The points line is priced off the variant, so it moves with it. */
    if (window.SCPoints) window.SCPoints.update(v.raw);
    elPrice.textContent = v.price;
    elSku.textContent = 'SKU ' + (v.sku || '–');

    if (v.hasCompare && v.compare) {
      elCompare.textContent = v.compare;
      elCompare.hidden = false;
      var now = +String(v.price).replace(/[^\d]/g, '');
      var was = +String(v.compare).replace(/[^\d]/g, '');
      if (was > now) {
        elSave.textContent = '-' + Math.round((was - now) / was * 100) + '%';
        elSave.hidden = false;
      } else { elSave.hidden = true; }
    } else {
      elCompare.hidden = true;
      elSave.hidden = true;
    }

    if (v.available) {
      elStock.textContent = 'In stock';
      elStock.removeAttribute('data-out');
      elAdd.disabled = false;
      elAdd.textContent = 'Add to cart';
    } else {
      elStock.textContent = 'Sold out';
      elStock.setAttribute('data-out', 'true');
      elAdd.disabled = true;
      elAdd.textContent = 'Sold out';
    }

    /* Repaints hero AND strip. A variant with no image of its own falls back to
       the product's featured image rather than leaving the previous variant's
       shot on screen. */
    if (gallery) {
      gallery.select(v.id);

      /* The ABOUT band further down the page carries a photo too. Left alone it
         keeps whatever the page was loaded with, so choosing Z-Players up top
         and scrolling down still showed a Z-Pro glove. It follows the same shot
         the hero is showing. */
      var story = document.getElementById('pda-story-img');
      var shot = gallery.current()[0];
      if (story && shot && story.getAttribute('src') !== shot.src) {
        /* The srcset was written for the OLD image; leaving it lets the browser
           keep serving the previous glove at some viewport widths. */
        story.removeAttribute('srcset');
        story.src = shot.src;
        if (shot.alt) story.alt = shot.alt;
      }
    }
  }

  /* SC_ACC already matches the normalised shape (optionNames + variants with
     id/opts/available/img); sku/compare/hasCompare/price ride along as extra
     fields the engine ignores but renderBuy() still needs. */
  var product = {
    optionNames: DATA.optionNames || [],
    variants: VARIANTS
  };

  window.SCVariantSelect.create(elOptions, product, renderBuy);

  root.querySelectorAll('[data-aqty]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var n = parseInt(elQty.value, 10) || 1;
      n += btn.getAttribute('data-aqty') === 'inc' ? 1 : -1;
      elQty.value = Math.max(1, n);
    });
  });

  var six = document.getElementById('sc-apdp-six');
  if (six) {
    six.addEventListener('click', function () {
      elQty.value = 6;
      elQty.focus();
    });
  }

  /* Add to cart opens the drawer instead of reloading the page onto /cart.
     The native form POST stays as the no-JS fallback: if this listener never
     runs, the form still submits the old way and nothing is lost. */
  var form = document.getElementById('sc-apdp-form');
  if (form) {
    form.addEventListener('submit', function (e) {
      /* Checked inside the handler, not at bind time: script order must not decide
         whether the drawer works. If SCCart truly never loads, we don't preventDefault
         and the native POST still adds the item. */
      if (!window.SCCart) return;
      e.preventDefault();
      var vid = document.getElementById('sc-apdp-vid');
      if (!vid || !vid.value || elAdd.disabled) return;
      var n = parseInt(elQty.value, 10) || 1;
      var label = elAdd.textContent;
      elAdd.disabled = true;
      elAdd.textContent = 'Adding…';
      window.SCCart.add(Number(vid.value), n).then(function () {
        elAdd.disabled = false;
        elAdd.textContent = label;
      });
    });
  }

}());
